/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSitesSearchRequest
 */
export interface UpdateSitesSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSitesSearchRequest
     */
    pattern: string;
}

/**
 * Check if a given object implements the UpdateSitesSearchRequest interface.
 */
export function instanceOfUpdateSitesSearchRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pattern" in value;

    return isInstance;
}

export function UpdateSitesSearchRequestFromJSON(json: any): UpdateSitesSearchRequest {
    return UpdateSitesSearchRequestFromJSONTyped(json, false);
}

export function UpdateSitesSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSitesSearchRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pattern': json['pattern'],
    };
}

export function UpdateSitesSearchRequestToJSON(value?: UpdateSitesSearchRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pattern': value.pattern,
    };
}

